module.exports = __webpack_public_path__ + "057153c1c41a88742c75e2a59a9c9697.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-420.jpg
// module id = 492
// module chunks = 0